{
  "chat": {
    "title": "Chat",
    "empty": "No chats yet",
    "loadError": "Could not load this conversation",
    "messagePlaceholder": "Message",
    "typing": "{{name}} is typing…",
    "typingTwo": "{{a}} and {{b}} are typing…",
    "typingMany": "Several people are typing…",
    "online": "Online",
    "offline": "Offline",
    "unread": "Unread",
    "startDm": "Message {{name}}",
    "members": "Members",
    "mute": "Mute this conversation",
    "unmute": "Unmute this conversation",
    "muted": "Muted"
  },
  "login": {
    "title": "Welcome back!",
    "description": "Enter your email address and we will send you a code to sign in.",
    "input": {
      "label": "Email address",
      "placeholder": "me@email.com"
    },
    "button": {
      "label": "Request code",
      "loading": "Sending code..."
    }
  },
  "verify": {
      "title": "Enter code",
      "description": "Enter the code we sent you by email to {{email}}.",
    "input": {
        "label": "Verification code",
      "placeholder": "00000000"
    },
    "button": {
        "label": "Verify code",
        "loading": "Verifying code..."
    },
    "buttonAbort": {
        "label": "Cancel"
    },
    "buttonResend": {
        "label": "Resend code"
    },
    "error": {
      "Invalid or expired OTP.": "Code is expired or invalid.",
      "invalidOtp": "Code is expired or invalid."
    }
  },
  "date": "{{value, datetime}}",
  "auth": {
    "logout": {
      "button": "Logout",
      "confirmTitle": "Logout",
      "confirmMessage": "Are you sure you want to logout?",
      "error": "Failed to logout. Please try again."
    }
  },
  "errors": {
    "types": {
      "authentication": "Authentication Error",
      "network": "Connection Problem",
      "generic": "Something went wrong"
    },
    "messages": {
      "sessionExpired": "Your session has expired. Please log in again.",
      "networkError": "Please check your internet connection and try again.",
      "genericError": "An unexpected error occurred. You can try refreshing the page or logging out.",
      "noOrg": "No organization found..."
    },
    "technical": {
      "title": "Technical Details:",
      "retryAttempts": "Retry attempts: {{current}}/{{max}}"
    },
    "actions": {
      "tryAgain": "Try Again",
      "loginAgain": "Log In Again",
      "logout": "Logout",
      "moreOptions": "More Options",
      "chooseAction": "Choose an action:",
      "refreshApp": "Refresh App",
      "debugData": "Debug Data",
      "clearCacheRetry": "Clear Cache & Retry"
    }
  },
  "common": {
    "currency": "{{value, currency}}",
    "decimalSeparator": ".",
    "loading": "Loading...",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "error": "Error",
    "success": "Success",
    "time": {
      "dayAgo": "1 day ago",
      "daysAgo": "{{count}} days ago",
      "weekAgo": "1 week ago",
      "weeksAgo": "{{count}} weeks ago",
      "monthsAgo": "{{count}} months ago",
      "secondsAbbr": "s"
    },
    "profile": "Profile"
  },
  "dashboard": {
    "error": {
      "orgNotFound": "Organization not found"
    },
    "quickActions": {
      "media": {
        "title": "All Media",
        "subtitle": "Browse library"
      },
      "achievements": {
        "title": "Achievements",
        "subtitle": "View progress"
      },
      "profile": {
        "title": "Member Pass",
        "subtitle": "Your details"
      },
      "membership": {
        "title": "Membership",
        "subtitle": "View plan"
      },
      "offers": {
        "title": "Offers",
        "subtitle": "Browse available"
      },
      "invite": {
        "title": "Invite Members",
        "subtitle": "Create QR code"
      },
      "chat": {
        "title": "Chat",
        "subtitle": "Talk with your groups"
      }
    },
    "sections": {
      "featuredVideos": "Featured Videos",
      "lastViewed": "Last viewed",
      "bookmarkedVideos": "Bookmarked Items",
      "recentAchievements": "Recent Achievements",
      "viewAllAction": "View All"
    }
  },
  "membership": {
    "paymentRequired": {
      "title": "Payment setup required",
      "subtitle": "Your membership was transferred to this organization. To continue, please set up your payment with one of the available payment methods.",
      "paidUntilNote": "Your already paid period is carried over — you will not be charged before {{date}}.",
      "bonusOffer_one": "Set up your payment by {{date}} and get {{count}} bonus month for free.",
      "bonusOffer_other": "Set up your payment by {{date}} and get {{count}} bonus months for free.",
      "openDashboard": "Set up payment in the web dashboard",
      "openDashboardHint": "For security reasons, payment setup happens in your browser. You will be logged in automatically.",
      "checkAgain": "I have completed the payment",
      "error": "The payment setup could not be started. Please try again."
    },
    "codeOfConduct": {
      "heading": "Code of conduct",
      "subtitle": "Please read the following text and accept it to continue using this organization.",
      "acceptLabel": "I have read and accept “{{title}}”.",
      "accept": "Accept",
      "acceptError": "Your consent could not be saved. Please try again.",
      "loadError": "The text could not be loaded.",
      "retry": "Try again",
      "newVersion": "A new version now applies. Please read it and accept it."
    },
    "title": "Membership",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "period": {
      "monthly": "Monthly",
      "yearly": "Yearly"
    },
    "pricing": {
      "per": {
        "monthly": "per month",
        "yearly": "per year"
      }
    },
    "sections": {
      "planDetails": "Details",
      "organization": "Organization"
    },
    "labels": {
      "billingPeriod": "Billing Period",
      "memberSince": "Member Since",
      "validUntil": "Valid Until",
      "cancelled": "Subscription cancelled"
    },
    "organization": {
      "memberDescription": "You are a member of this organization"
    },
    "management": {
      "title": "Manage Your Subscription",
      "description": "To make changes to your subscription, please use the OctaHub WebApp or contact {{organizationName}} directly."
    },
    "dashboard": {
      "title": "Open Dashboard",
      "subtitle": "Manage your subscription and settings",
      "openError": "Failed to open dashboard. Please try again."
    }
  },
  "media": {
    "download": {
      "button": "Download",
      "available": "Offline Available"
    },
    "screens": {
      "bookmarks": "Bookmarked Videos",
      "lastViewed": "Last Viewed Videos",
      "library": "Media"
    },
    "bookmark": {
      "save": "Save",
      "saved": "Saved",
      "bookmarkLabel": "Bookmark",
      "bookmarkedLabel": "Bookmarked"
    },
    "folder": {
      "itemCount_one": "{{count}} item",
      "itemCount_other": "{{count}} items",
      "folderDescription": "Folder with {{count}} items"
    },
    "sharedFolders": {
      "upload": "Upload",
      "newFolder": "New Folder",
      "folderNamePlaceholder": "Folder name...",
      "uploading": "Uploading...",
      "uploadProgress": "{{progress}}%",
      "uploadSuccess": "File uploaded successfully",
      "uploadError": "Upload failed",
      "uploadErrorMessage": "An error occurred while uploading. Please try again.",
      "uploadSubtitle": "Upload a file to this folder",
      "newFolderSubtitle": "Create a new subfolder"
    },
    "navigation": {
      "previous": "Previous",
      "next": "Next"
    },
    "relatedVideos": "Related Content",
    "delete": {
      "button": "Delete",
      "confirmTitle": "Delete Media",
      "confirmMessage": "Are you sure you want to delete this item? This action cannot be undone.",
      "success": "Media deleted successfully",
      "error": "Delete failed",
      "errorMessage": "Could not delete this media item. Please try again.",
      "errorInUse": "This media item is used in one or more offers and cannot be deleted."
    }
  },
  "achievements": {
    "title": "Achievements",
    "subtitle": "Your earned accomplishments",
    "count_zero": "No achievements earned",
    "count_one": "{{count}} Achievement Earned",
    "count_other": "{{count}} Achievements Earned",
    "earned": "Earned {{time}}",
    "emptyState": {
      "title": "No Achievements Yet",
      "description": "Complete courses and activities to earn your first achievement!"
    }
  },
  "noOrg": {
    "title": "No Organizations Found",
    "description": "You don't have access to any organizations yet. Please contact your administrator to get access to an organization or check back later.",
    "actions": {
      "title": "What you can do:",
      "contactAdmin": "Contact your organization administrator",
      "askInvitation": "Ask for an invitation to join",
      "checkAccount": "Check if you are using the correct account",
      "tryRelogin": "Try logging out and back in"
    }
  },
  "offers": {
    "title": "Offers",
    "detailsTitle": "Offer Details",
    "notFound": "Offer Not Found",
    "notFoundMessage": "This offer could not be found",
    "noOffers": "No offers available at the moment",
    "purchased": "Purchased",
    "free": "Free",
    "purchaseWebOnly": "Purchase on web-app only",
    "claimOffer": "Claim Offer",
    "purchase": "Purchase",
    "purchasedBadge": "✓ You already own this offer",
    "youOwnThis": "You have access to all content in this offer",
    "missingAchievements": "⚠️ You don't have the required achievements for this offer. You are still missing: {{missing}}",
    "mobileNotAvailable": "⚠️ Purchases are not available in the mobile app",
    "mobileNotAvailableSubtext": "Please visit our website to purchase this offer",
    "price": "Price:",
    "includedContent": "Included Content",
    "includedAchievements": "Included Achievements",
    "videoCount_one": "{{count}} Video",
    "videoCount_other": "{{count}} Videos",
    "audioCount_one": "{{count}} Audio",
    "audioCount_other": "{{count}} Audios",
    "pdfCount_one": "{{count}} PDF",
    "pdfCount_other": "{{count}} PDFs",
    "documentCount_one": "{{count}} Document",
    "documentCount_other": "{{count}} Documents",
    "imageCount_one": "{{count}} Image",
    "imageCount_other": "{{count}} Images",
    "achievementCount_one": "{{count}} Achievement",
    "achievementCount_other": "{{count}} Achievements",
    "paymentDenied": {
      "title": "Payment Not Available",
      "description": "This offer is not available for purchase in your region"
    },
    "pricing": {
      "netAmount": "Net Amount"
    },
    "errors": {
      "general": "Error",
      "purchaseFailed": "Failed to process purchase",
      "webOnly": "Purchases are only available on the web version"
    },
    "success": {
      "claimed": "Offer claimed successfully!"
    },
    "paymentProviders": {
      "selectTitle": "Select Payment Method",
      "selectSubtitle": "Choose how you'd like to pay",
      "stripe": {
        "name": "Stripe",
        "description": "Credit Card, Debit Card, Apple Pay, Google Pay"
      },
      "paypal": {
        "name": "PayPal",
        "description": "PayPal Balance, Credit Card, Bank Account"
      }
    },
    "payment": {
      "processing": "Processing your payment...",
      "success": {
        "title": "Payment Successful!",
        "message": "Your purchase has been completed successfully. You now have access to the content.",
        "viewOffer": "View Offer",
        "backToOffers": "Back to Offers"
      },
      "pending": {
        "title": "Payment Processing",
        "message": "Your payment is still being processed. This may take a few moments...",
        "checkStatus": "Check Status"
      },
      "failed": {
        "title": "Payment Failed",
        "message": "Your payment could not be completed. Please try again.",
        "tryAgain": "Try Again"
      }
    }
  },
  "orgSelection": {
    "title": "Select Organization",
    "subtitle": "Choose an organization to continue",
    "switchOrg": "Switch Organization",
    "switchOrgSubtitle": "Change to a different organization",
    "currentOrg": "Current"
  },
  "profile": {
    "myPurchases": "My Purchases",
    "idPrefix": "ID: "
  },
  "settings": {
    "language": {
      "title": "Language",
      "subtitle": "Select your preferred language",
      "systemDefault": "System Default"
    },
    "notifications": {
      "title": "Notifications",
      "subtitle": "Choose what you want to be notified about",
      "chat": "Chat messages",
      "chatHint": "Get notified about new messages in your conversations",
      "seeAll": "See all notifications",
      "permissionDenied": "Notifications are turned off for this app in your device settings."
    }
  },
  "openWebApp": "Open Web App",
  "openWebAppSubtext": "Manage your account, purchases and more at {{url}}",
  "openWebAppError": "Failed to open web app. Please try again.",
  "invite": {
    "title": "Invite Members",
    "selectPlan": "Select a membership plan",
    "selectGroup": "Select a group",
    "generating": "Generating...",
    "scanToJoin": "Scan this QR code to join",
    "createAnother": "Create Another",
    "error": {
      "createFailed": "Failed to create invitation. Please try again.",
      "noPlans": "No membership plans available."
    }
  },
  "notifications": {
    "title": "Notifications",
    "empty": "No notifications yet",
    "markAllRead": "Mark all read",
    "unread": "Unread",
    "loadError": "Could not load your notifications",
    "chat": {
      "messageGroup": {
        "title": "{{channel}}",
        "body": "{{sender}}: {{preview}}"
      },
      "messageDm": {
        "title": "{{sender}}",
        "body": "{{preview}}"
      }
    },
    "common": {
      "newMessage": "New message"
    }
  }
}
